import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import {
  VApp,
  VNavigationDrawer,
  VFooter,
  VToolbar,
  VFadeTransition,
} from 'vuetify/components'
import { Ripple } from 'vuetify/directives'

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',    
  },
  theme: {
    defaultTheme: 'light',
    //
  },
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VToolbar,
    VFadeTransition,
  },
  directives: {
    Ripple
  },
})

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default vuetify